import React from "react";

function Image({
  src,
  alt = "Image",
  className = "",
  ...props
}) {
  const handleError = (e) => {
    if (!e.currentTarget.dataset.fallback) {
      e.currentTarget.dataset.fallback = "true";
      e.currentTarget.src = "/assets/images/no_image.png";
    }
  };

  return (
    <img
      src={src || "/assets/images/no_image.png"}
      alt={alt}
      className={className}
      onError={handleError}
      loading="lazy"
      {...props}
    />
  );
}

export default Image;
